import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-music",
  "use": "icon-music-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-music\">\n<path d=\"M9.93413 21.2273C8.7963 21.2273 7.8223 20.8221 7.01213 20.0118C6.2018 19.2016 5.79663 18.2276 5.79663 17.0898C5.79663 15.9519 6.2018 14.9779 7.01213 14.1675C7.8223 13.3574 8.7963 12.9523 9.93413 12.9523C10.2893 12.9523 10.6175 12.9921 10.9186 13.0718C11.22 13.1514 11.5126 13.271 11.7966 13.4305V2.77277H18.2091V7.04777H14.0716V17.0898C14.0716 18.2276 13.6665 19.2016 12.8561 20.0118C12.046 20.8221 11.072 21.2273 9.93413 21.2273Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol